// Late Pass System - Mock Data

export const currentUser = {
  id: 1,
  name: "הרב יוסף גאלדבערגער",
  nameEn: "Rabbi Yosef Goldberger",
  role: "admin",
  roleLabel: "הנהלה",
};

export const klasn = [
  { id: 1, name: "פרי א'" },
  { id: 2, name: "פרי ב'" },
  { id: 3, name: "כתה א'" },
  { id: 4, name: "כתה ב'" },
  { id: 5, name: "כתה ג'" },
  { id: 6, name: "כתה ד'" },
  { id: 7, name: "כתה ה'" },
  { id: 8, name: "כתה ו'" },
];

const firstNames = ["מרדכי", "שלמה", "אברהם", "יצחק", "יעקב", "משה", "אהרן", "יוסף", "דוד", "שמואל", "מנחם", "נחמן", "יהודה", "שמעון", "לוי", "ראובן", "בנימין", "נפתלי", "אשר", "גד", "זבולון", "יששכר", "אליעזר", "אלימלך", "פנחס", "נתן", "חיים", "ברוך", "ישראל", "מאיר"];
const lastNames = ["גאלדבערג", "פרידמאן", "וויס", "ראזנבערג", "קאהן", "שווארטץ", "גרין", "הירש", "בערגער", "לעווי", "קליין", "רובין", "שטיין", "פיש", "בלום", "רוט", "קרויס", "מילער", "אדלער", "האלפערן", "ברוין", "וויינברג"];

export const talmidim = Array.from({ length: 120 }, (_, i) => {
  const fn = firstNames[i % firstNames.length];
  const ln = lastNames[(i * 3) % lastNames.length];
  const father = firstNames[(i + 5) % firstNames.length];
  const klas = klasn[i % klasn.length];
  return {
    id: i + 1,
    firstName: fn,
    lastName: ln,
    fullName: `${fn} ${ln}`,
    fatherName: father,
    klasId: klas.id,
    klasName: klas.name,
  };
});

export const commonReasons = [
  "דאקטער אפאינטמענט",
  "צאהנארזט אפאינטמענט",
  "פארשלאפן",
  "טראנספארט פראבלעם",
  "משפחה עמערזענסי",
  "דאקטערס באזוך",
  "שמחה משפחתית",
  "אנדערע",
];

function randomTime(hour = 9) {
  const h = hour + Math.floor(Math.random() * 2);
  const m = Math.floor(Math.random() * 60);
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

// Generate historic passes
export const initialPasses = (() => {
  const arr = [];
  const today = new Date();
  for (let d = 0; d < 45; d++) {
    const date = new Date(today);
    date.setDate(today.getDate() - d);
    if (date.getDay() === 6) continue;
    const perDay = Math.floor(Math.random() * 4) + (d === 0 ? 3 : 1);
    for (let j = 0; j < perDay; j++) {
      const t = talmidim[(d * 7 + j * 3) % talmidim.length];
      arr.push({
        id: `LP-${(1000 + arr.length).toString()}`,
        talmidId: t.id,
        talmidName: t.fullName,
        fatherName: t.fatherName,
        klasId: t.klasId,
        klasName: t.klasName,
        date: date.toISOString().slice(0, 10),
        time: randomTime(),
        reason: commonReasons[(d + j) % commonReasons.length],
        signedBy: currentUser.name,
        createdAt: date.toISOString(),
      });
    }
  }
  return arr.sort((a, b) => (b.createdAt > a.createdAt ? 1 : -1));
})();
